import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext.js';
import { homePathForAuthUser } from '../../auth/routing.js';

export function PlatformAccessDeniedPage() {
  const { user } = useAuth();
  const home = user ? homePathForAuthUser(user) : '/';

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>Platform access restricted</h1>
        <p>
          Platform administration is limited to authorized ScrubLedger operators. Program users should
          continue in their assigned workspace.
        </p>
        <div className="public-simple-page__actions">
          <Link to={home} className="btn btn--primary">Go to my workspace</Link>
          <Link to="/" className="btn btn--ghost">Home</Link>
        </div>
      </div>
    </div>
  );
}
